import { useState } from "react";

import { Link, useNavigate } from "react-router-dom";

import { MoveLeftIcon } from "lucide-react";

import "./ForgetPasswordForm.css";

import service from "../../services/service";
import endpoints from "../../services/endpoints";

export default function ForgotPasswordForm() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);

      const payload = {
        email,
      };

      const res = await service.post(endpoints.auth.forgotPassword, payload);

      const isSuccess = res?.status === 200 || res?.status === 201;

      if (!isSuccess) {
        return;
      }
      navigate("/verify-email", {
        state: {
          email,
          purpose: "forgot-password",
        },
      });
    } catch (error) {
      console.log("FORGOT PASSWORD ERROR", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-form-wrapper">
      {/* Back */}
      <Link to="/login" className="forgot-back-btn">
        <MoveLeftIcon size={20} />
        <span>Back</span>
      </Link>

      {/* Heading */}
      <div className="login-heading">
        <h1>Forgot Password</h1>

        <p>Enter Your Email to get OTP</p>
      </div>

      {/* Form */}
      <form className="login-form" onSubmit={handleConfirm}>
        {/* Email */}
        <div className="form-group">
          <label>Email ID</label>

          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {/* Button */}
        <button type="submit" className="auth-login-btn" disabled={isLoading}>
          {isLoading ? "Confirming..." : "Confirm"}
        </button>
      </form>
    </div>
  );
}
